import { Link } from "react-router-dom";
import { Mail, MapPin, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6 relative overflow-hidden">
      {/* Floating postal ephemera */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Postmark */}
        <div className="absolute top-[15%] right-[10%] w-24 h-24 rounded-full border-2 border-primary/20 flex items-center justify-center rotate-12">
          <span className="text-primary/20 text-xs font-mono text-center leading-tight">
            RETURN<br/>TO<br/>SENDER
          </span>
        </div>
        
        {/* Stamp outline */}
        <div className="absolute bottom-[20%] left-[8%] w-16 h-20 border-2 border-dashed border-tan/40 rotate-[-8deg]" />
        
        {/* Envelope corner */}
        <div className="absolute top-[30%] left-[15%] w-0 h-0 border-l-[30px] border-l-transparent border-t-[30px] border-t-tan/30 rotate-[20deg]" />
        
        {/* Another postmark */}
        <div className="absolute bottom-[30%] right-[15%] w-16 h-16 rounded-full border border-primary/15 rotate-[-20deg]" />
      </div>

      <div className="max-w-md w-full text-center space-y-8 relative z-10">
        {/* Lost letter illustration */}
        <div className="mx-auto w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
          <div className="relative">
            <Mail className="h-10 w-10 text-primary" />
            <MapPin className="h-5 w-5 text-primary/60 absolute -bottom-1 -right-2" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-4">
          <h1 className="font-serif text-4xl md:text-5xl text-foreground">
            Lost in Transit
          </h1>
          <p className="text-muted-foreground font-sans text-lg leading-relaxed max-w-sm mx-auto">
            This page seems to have wandered off the map. Even after all my travels, 
            I couldn't find what you're looking for here.
          </p>
        </div>

        {/* Signature */}
        <p className="font-serif text-primary italic text-lg">
          — Eunice
        </p>

        {/* Action */}
        <div className="pt-4">
          <Button asChild variant="eunice" size="lg">
            <Link to="/">
              <Home className="h-4 w-4 mr-2" />
              Return Home
            </Link>
          </Button>
        </div>

        {/* Subtle help text */}
        <p className="text-sm text-muted-foreground font-sans pt-4">
          If you believe this is a mistake, please{" "}
          <a
            href="mailto:letters@eunice.world"
            className="text-primary hover:underline"
          >
            send me a letter
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
